<!-- Migrated from legacy/Plus/Plus/Contact/index.shtml -->

<template>
  <h4>How To Contact Us</h4>
  <p>Please send email to <Email to="vizbi-contact" />.</p>
</template>

<script setup>
import Email from "@/components/Email";
</script>

